module.exports = __webpack_public_path__ + "img/2x.be14ce9.jpg";